import {
  GET_ORGANIZATION_AGENT_ERROR,
  GET_ORGANIZATION_AGENT_START,
  GET_ORGANIZATION_AGENT_SUCCESS,
} from 'constants/action-types/organizations/getAgent';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_ORGANIZATION_AGENT_START:
      return {
        ...state,
        getAgent: {
          ...state.getAgent,
          loading: true,
          error: null,
        },
      };
    case GET_ORGANIZATION_AGENT_ERROR:
      return {
        ...state,
        getAgent: {
          ...state.getAgent,
          error: payload,
          loading: false,
        },
      };
    case GET_ORGANIZATION_AGENT_SUCCESS:
      return {
        ...state,
        getAgent: {
          ...state.getAgent,
          data: payload.data,
          loading: false,
        },
      };
    default:
      return null;
  }
};
